import { render } from "./why-e4t-page-top.vue?vue&type=template&id=71bb4cd2&ts=true"
import script from "./why-e4t-page-top.vue?vue&type=script&lang=ts"
export * from "./why-e4t-page-top.vue?vue&type=script&lang=ts"

import "./why-e4t-page-top.vue?vue&type=style&index=0&id=71bb4cd2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__